import { setup } from './server.config';

const defaultRequest = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const apiConfig = {
  api: {
    base_url: setup.API_URL,
    defaultRequest,
    apiVerStoreKey: 'apiVersion',
  },
  direct_feedback: {
    base_url: setup.DIRECT_FEEDBACK_URL,
    defaultRequest,
    apiVerStoreKey: 'directFeedbackVersion',
  },
  pulse_check: {
    base_url: setup.PULSE_CHECK_URL,
    defaultRequest,
    apiVerStoreKey: 'pulseCheckVersion',
  },
  reporting: {
    base_url: setup.REPORTING_URL,
    defaultRequest,
    apiVerStoreKey: 'reportingApiVersion',
  },
  lxApp: {
    base_url: setup.LX_APP_URL,
    defaultRequest,
  },
  userServiceApi: {
    base_url: setup.USER_SERVICE_API,
    defaultRequest,
  },
  okr: {
    base_url: setup.OKR_API,
    defaultRequest,
  },
  notes: {
    base_url: setup.NOTES_API,
    defaultRequest,
  },
  logService: {
    base_url: setup.LOG_SERVICE_URL,
    defaultRequest,
  },
  debug: setup.DEBUG,
  log_level: setup.LOG_LEVEL,
  log_level_prevent_spam: setup.LOG_LEVEL_PREVENT_SPAM,
  translation_service: {
    host: setup.TRANSLATION_SERVICE_HOST,
    published: setup.PUBLISHED,
  },
};
